<div class="country-phone-input" [formGroup]="form">
  <div class="country-phone-input__country" [class.full-width]="countryOnly">
    <label class="form-label" for="countryPhoneCountry" *ngIf="!countryOnly">Country</label>
    <app-country-select
      formControlName="country"
      [inputClass]="inputClass"
      [disabled]="lockCountry"
      (blur)="onBlur()">
    </app-country-select>
  </div>

  <div class="country-phone-input__phone" *ngIf="!countryOnly">
    <label class="form-label" for="countryPhoneNumber">Phone Number</label>
    <div class="phone-row">
      <span class="dial-code" *ngIf="dialCode">{{ dialCode }}</span>
      <input
        type="tel"
        id="countryPhoneNumber"
        class="form-input phone-input"
        [class]="inputClass"
        formControlName="phone"
        placeholder="Phone number"
        (blur)="onBlur()"
      />
    </div>
    <p class="form-help error" *ngIf="phoneError">{{ phoneError }}</p>
  </div>
</div>
